import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'verse'),
  es: flattenMessages(es, 'verse'),
  ru: flattenMessages(ru, 'verse'),
  zh: flattenMessages(zh, 'verse'),
};
